import { createClient } from "@sanity/client";
import { createImageUrlBuilder } from '@sanity/image-url'

// Define a simple type for Sanity image sources
type SanityImageSource = {
  _type?: string;
  asset?: {
    _ref?: string;
    _type?: string;
    url?: string;
  };
};

export const client = createClient({
  projectId: process.env.NEXT_PUBLIC_SANITY_PROJECT_ID,
  dataset: process.env.NEXT_PUBLIC_SANITY_DATASET,
  apiVersion: "2024-01-01",
  useCdn: true,
});

const builder = createImageUrlBuilder(client);

export function urlFor(source: SanityImageSource) {
  // Always render the original image framing on the frontend.
  // This ignores Studio crop/hotspot so images are not unexpectedly clipped.
  return builder.image(source).ignoreImageParams();
}

// GROQ Queries
export const postsQuery = `*[_type == "post"] | order(publishedAt desc) {
  _id,
  title,
  "slug": slug.current,
  mainImage,
  excerpt,
  publishedAt,
  author->{
    name
  }
}`;

export const postBySlugQuery = `*[_type == "post" && slug.current == $slug][0] {
  _id,
  _updatedAt,
  title,
  "slug": slug.current,
  excerpt,
  mainImage,
  body[]{
    ...,
    _type == "image" => {
      ...,
      "dimensions": asset->metadata.dimensions
    }
  },
  publishedAt,
  author->{
    name,
    image
  }
}`;

export const postTitleBySlugQuery = `*[_type == "post" && slug.current == $slug][0]{
  title,
  excerpt
}`;

export const plansQuery = `*[_type == "plan"] | order(price asc) {
  _id,
  name,
  price,
  description,
  features,
  isRecommended
}`;

export const carouselImagesQuery = `*[_type == "carouselImage"] | order(order asc) {
  _id,
  title,
  image,
  alt
}`;
